var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingProClickLongLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 106,
    viewBox: "0 0 87 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 53.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8453 65.333H59.2453V51.533C59.2453 48.133 59.2453 40.733 48.9953 40.733C45.1953 40.733 41.4453 41.883 38.7953 44.583L41.9453 47.733C43.5453 46.233 45.8453 45.233 48.3453 45.233C51.5453 45.233 53.8453 46.783 53.8453 49.733V50.383H52.3453C46.3453 50.383 37.2453 50.933 37.2453 58.733C37.2453 63.483 41.5453 65.933 45.9953 65.933C49.1953 65.933 51.9953 64.733 53.6953 62.033H53.8453V65.333ZM53.4953 55.933C53.4953 59.283 51.5453 61.433 47.4453 61.433C45.4953 61.433 43.2453 60.483 43.2453 58.283C43.2453 54.833 48.9453 54.583 52.2453 54.583H53.4953V55.933Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 9)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 26,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 26)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 43,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 43)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 60,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 60)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 77,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 77)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 94,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 94)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingProClickLongLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-proClick-long-left.d075c8d67e44798f0f77048fc8798ecf.svg";
export { ForwardRef as ReactComponent };